import styled from 'styled-components/macro';
import {
  PrimaryButton,
  OutlineButton
} from '../../../../../components/ButtonStyles';
import { BlueTextLinkButton } from '../../../../../components/LinkStyles';

export const RowActionButtonsDiv = styled.div`
  display: flex;
  margin-top: 30px;
`;

export const ActionRowButtons = styled(BlueTextLinkButton)`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  svg {
    margin-right: 5px;
  }
`;

export const DetailRowDiv = styled.div`
  border-top: 2px solid white;
  padding: 2rem 0 3.5rem;

  p,
  h6 {
    padding: 2px 0;
    display: inline-block;
    line-height: 2rem;
  }
  h6 {
    width: 105px;
  }
  p {
    width: calc(100% - 105px);
    word-wrap: break-word;
  }
`;

export const EditRowButton = styled(PrimaryButton)`
  display: flex;
  font-weight: 600;
  font-size: 12px;
  width: 120px;
  height: 36px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  margin-right: 22px;
  svg {
    margin-right: 7px;
    width: 11px;
  }
`;

export const DeleteRowButton = styled(OutlineButton)`
  display: flex;
  font-size: 12px;
  width: 120px;
  height: 36px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  svg {
    fill: ${props => props.theme.blue};
    margin-right: 7px;
    width: 10px;
  }
`;
